<template>
  <ul
    v-if="isVisible"
    class="border-gray-20 mb-1 border-b pb-1 last:mb-0 last:border-b-0 last:pb-0"
    :class="{ 'first:pt-1': !$slots.name }"
  >
    <li
      v-if="$slots.name"
      class="text-gray-60 cursor-default pb-2 pl-3 pr-4 text-left"
      :class="headingThemeClasses[headingTheme]"
    >
      <slot name="name" />
    </li>

    <slot />

    <div v-if="!hasSlotContent($slots.default) && $slots.empty" class="px-3 py-1 text-sm font-medium text-gray-50">
      <slot name="empty" />
    </div>
    <li v-if="$slots.more" class="px-3 py-1 text-left text-sm font-medium text-gray-50">
      <slot name="more" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { hasSlotContent } from '@klausapp/shared/utils/slot'

import { UiMenuGroupTheme } from './types'

withDefaults(
  defineProps<{
    headingTheme?: UiMenuGroupTheme
  }>(),
  {
    headingTheme: UiMenuGroupTheme.Default,
  },
)

const slots = useSlots()

const isVisible = computed(() => hasSlotContent(slots.default) || hasSlotContent(slots.empty))

const headingThemeClasses = {
  [UiMenuGroupTheme.Default]: 'font-medium text-xs pt-2',
  [UiMenuGroupTheme.Uppercase]: 'font-bold text-caps pt-4',
}
</script>
